let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lUP2o")).then(() => parcelRequire('76Z88'));